export default function About() {
  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>¿Qué es Vortex Software?</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            Empresa especializada en el desarrollo de aplicaciones móviles innovadoras que transforman la educación y el aprendizaje.
          </p>
        </div>

        <div className="grid grid-3">
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'var(--accent)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              margin: '0 auto var(--spacing-lg) auto'
            }}>
              <img src="/icons/ai.png" alt="Innovación" style={{ width: '65px' }} />
            </div>
            <h3>Innovación Tecnológica</h3>
            <p>
              Utilizamos las últimas tecnologías como IA y machine learning para crear experiencias únicas.
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'var(--accent)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              margin: '0 auto var(--spacing-lg) auto'
            }}>
              <img src="/icons/books.png" alt="Viaje profesional" style={{ width: '65px' }} />
            </div>
            <h3>Enfoque Educativo</h3>
            <p>
              Desarrollamos aplicaciones que facilitan el aprendizaje y el crecimiento personal.
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'var(--accent)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              margin: '0 auto var(--spacing-lg) auto'
            }}>
              <img src="/icons/read.png" alt="Viaje profesional" style={{ width: '65px' }} />
            </div>
            <h3>Comunidad Activa</h3>
            <p>
              Construimos comunidades alrededor de nuestras apps para compartir conocimientos.
            </p>
          </div>
        </div>

        <div style={{
          marginTop: 'var(--spacing-2xl)',
          padding: 'var(--spacing-2xl)',
          background: 'var(--bg-tertiary)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            Nuestra misión es transformar la educación a través de la tecnología.
          </h3>
          <p style={{ textAlign: 'justify', fontSize: '1.125rem', maxWidth: '800px', margin: '0 auto' }}>
            Vortex Software se dedica al desarrollo de aplicaciones móviles que combinan innovación tecnológica con contenido educativo de calidad. Desde herramientas de estudio avanzadas hasta plataformas de gestión comunitaria, nuestras apps están diseñadas para potenciar el aprendizaje, fomentar la colaboración y facilitar el acceso al conocimiento. Con un enfoque en la experiencia del usuario y el uso de inteligencia artificial, creamos soluciones que se adaptan a las necesidades de estudiantes, profesionales y organizaciones.
          </p>
        </div>
      </div>
    </section>
  )
} 